import React from "react";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import type {NodeViewProps} from "@tiptap/react";
import PrintoutBlockShell from "../shared/PrintoutBlockShell";
import WritingAreaView from "./WritingAreaView";
import {getWritingAreaAttrs} from "./printoutWritingAreaOptions";
import type {PrintoutWritingAreaAttrs} from "./printoutWritingAreaOptions";

const PrintoutWritingAreaNodeView = (props: NodeViewProps) => {
    const attrs = getWritingAreaAttrs(props.node.attrs as PrintoutWritingAreaAttrs);

    return (
        <PrintoutBlockShell
            {...props}
            blockType="printoutWritingArea"
            icon={<EditNoteOutlinedIcon fontSize="small"/>}
            label="Writing area"
        >
            <WritingAreaView attrs={attrs}/>
        </PrintoutBlockShell>
    );
};

export default PrintoutWritingAreaNodeView;
